import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";

import { Observable, Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";
import { AppState, getTimezone } from "src/app/store/reducers";

import { setTimezone } from "src/app/store/actions/tenant/tenant.actions";

@Component({
  selector: "app-timezone-select",
  templateUrl: "./timezone-select.component.html",
  styleUrls: ["./timezone-select.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TimezoneSelectComponent implements OnInit, OnDestroy {
  public timezones: { code: string; description: string }[] = [];

  public selectedTimezone: { code: string; description: string };

  timezone$: Observable<string>;
  timezoneSubscription: Subscription;

  constructor(private store: Store<AppState>) {
    this.timezone$ = this.store.pipe(select(getTimezone));
  }

  ngOnInit() {
    // const offset = this.getTimezoneOffsetString();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    this.timezones = [
      // { code: 'UTC', description: 'UTC' },
      // { code: 'LOCAL', description: `Local (${offset})` }
      { code: 'LOCAL', description: timeZone }
    ];

    this.timezoneSubscription = this.timezone$.subscribe((tzCode) => {
      this.selectedTimezone = this.timezones.find(tz => tz.code === tzCode);
    });
  }

  changeTimezone() {
    this.store.dispatch(setTimezone({ timezone: this.selectedTimezone.code}))
  }

  private getTimezoneOffsetString(): string {
    const offsetMinutes = new Date().getTimezoneOffset();
    const totalMinutes = -offsetMinutes;
    const sign = totalMinutes >= 0 ? '+' : '-';
    const hours = Math.floor(Math.abs(totalMinutes) / 60)
      .toString()
      .padStart(2, '0');
    const minutes = (Math.abs(totalMinutes) % 60).toString().padStart(2, '0');
    return `${sign}${hours}:${minutes}`;
  }

  ngOnDestroy() {
    if (this.timezoneSubscription) {
      this.timezoneSubscription.unsubscribe();
    }
  }
}
